<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<section class="login-wrap bg-login">
    <div class="container">


        <div class="row align-items-center justify-content-center">
            <!-- Start Signinup Wrap -->
            <div class="col-12 col-sm-10 col-md-7 col-lg-5">
                <div class="signinup-content-wrap overflow-hidden rounded p-4 p-md-5 ">
                    <div class="signinup-header pb-4">
                        <div class="logo-box">
                            <!-- <img src="assets/images/dark_logo.png" class="logo-login" alt="Login logo"> -->
                        </div>
                        <h3 class="title white primaryfont pt-5"> Welcome back to HVF </h3>
                        <!-- <p> Find the most popular posts in your area. </p> -->
                    </div>
                    <div class="signinup-form">
                        <form autocomplete="off" [formGroup]="loginData" (ngSubmit)="Onsubmit()">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group pb-3">
                                        <label class="form-label white" for="Username"> Email </label>
                                        <input type="email" class="form-control" id="Username" placeholder="lisa@gmail.com" aria-describedby="errorEmail" formControlName="email" [(ngModel)]="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <small id="errorEmail" class="errormessage text-danger d-inline-block pt-2" *ngIf="submitted && f.email.errors"> 
                                                    <div *ngIf="f['email'].errors['required']"> Email is required </div>
                                                    <div *ngIf="f['email'].errors['email']"> Email must be a valid email </div>
                                                </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group pb-3">
                                        <label class="form-label white" for="Password">Password</label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field" placeholder="***********" minlength="6" [(ngModel)]="password" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password')"> 
                                            <i class="bx bx-low-vision toggle-password" toggle="#password-field"></i> 
                                        </span>
                                        </div>
                                        <small id="errorEmail" *ngIf="submitted && f.password.errors" class="errormessage text-danger d-inline-block pt-2">
                                                    <div *ngIf="f['password'].errors['required']">Password is required</div>
                                                    <div *ngIf="f['password'].errors['pattern']">Password must be at least 8 characters long and contain at least one special character, one uppercase letter, one lowercase letter, and one number.</div>
                                                </small>
                                    </div>
                                </div>

                                <div class="col-md-6 pb-3 pb-md-0">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" value="" id="AuthorisedRepresentative" [checked]="rememberCheck" (change)="getCheckType($event)">
                                        <label class="form-check-label white" for="flexSwitchCheckChecked">Remember Me</label>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                            <div class="form-link pb-2 text-end col-12">
                                                <a routerLink="/forgot-password" class="bluelight-color"> Forgot password? </a>
                                            </div>
                                        </div> -->
                                <div class="form-btn-box pt-4 col-12">
                                    <button type="submit" class="btn custom-btn gradient1-btn px-4 w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- <div class="signinup-footer pt-4 text-center">
                                <p> Not a member? <a class="font-w-bold" routerLink="/signup"> Sign Up </a> </p>
                            </div> -->
                </div>
            </div>
            <!-- End Signinup Wrap -->
        </div>
        <!--end row-->

    </div>
</section>
